import { 
  AreaChart, 
  Area, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer,
  Legend
} from 'recharts';

const PriceChart = ({ data, title, energyType = 'electricity', contractName }) => {
  // PDE colors: Azur for gas, Ambre for electricity
  const color = energyType === 'gas' ? '#397DFF' : '#F9C80E';
  const gradientId = `gradient-${energyType}-${contractName?.replace(/\s+/g, '-') || 'chart'}`;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white border border-[#BFC6CC]/30 rounded-lg p-3 shadow-lg">
          <p className="text-[#687175] text-sm mb-1">{label}</p>
          <p className="text-[#191D1E] font-mono font-bold">
            {payload[0].value?.toFixed(2)} €/MWh
          </p>
          {payload[0].payload.variation_pct && (
            <p className={`text-sm ${payload[0].payload.variation_pct >= 0 ? 'text-red-500' : 'text-[#10D183]'}`}>
              {payload[0].payload.variation_pct >= 0 ? '+' : ''}{payload[0].payload.variation_pct.toFixed(2)}%
            </p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white border border-[#BFC6CC]/30 rounded-xl p-4 md:p-6 shadow-sm">
      <h3 className="text-lg font-bold text-[#191D1E] mb-4">{title}</h3>
      <div className="h-64 md:h-80">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
            <defs>
              <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.2} />
                <stop offset="95%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#BFC6CC" strokeOpacity={0.3} />
            <XAxis 
              dataKey="date" 
              stroke="#687175" 
              fontSize={12}
              tickFormatter={(value) => {
                const date = new Date(value);
                return `${date.getDate()}/${date.getMonth() + 1}`;
              }}
            />
            <YAxis 
              stroke="#687175" 
              fontSize={12}
              tickFormatter={(value) => `${value}€`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="monotone"
              dataKey="price"
              stroke={color}
              strokeWidth={2}
              fillOpacity={1}
              fill={`url(#${gradientId})`}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PriceChart;
